// extracted by mini-css-extract-plugin
export var card = "styles-module--card--4be97";
export var cardContent = "styles-module--cardContent--5aee2";
export var cardHeading = "styles-module--cardHeading--3b96f";
export var cardHeadingIcon = "styles-module--cardHeadingIcon--6ef90";
export var cardIcon = "styles-module--cardIcon--941bf";
export var cardWrapper = "styles-module--cardWrapper--c2e90";
export var cards = "styles-module--cards--74c61";